const Fonts = {
  playfair: "'Playfair Display', Arial, serif",
  alex: "'Alex Brush', cursive",
  roboto: "'Roboto', Arial, serif",
};

export default Fonts;
